import { render } from "./SplashScreen.vue?vue&type=template&id=31136b12&scoped=true"
const script = {}

import "./SplashScreen.vue?vue&type=style&index=0&id=31136b12&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31136b12"]])

export default __exports__